import { Pipe, PipeTransform } from '@angular/core';
import { formatNumber } from '@angular/common';
import { PhxTranslationService } from '../../translation/translation.service';

type PhxDistanceUnitType = 'mile' | 'km';

const MILES_PER_KM: number = 0.621371; // if there is common file to store these, we can move it there

function kmToMiles(kms: number): number {
  return MILES_PER_KM * kms;
}

function milesToKm(miles: number): number {
  return miles / MILES_PER_KM;
}

@Pipe({ name: 'phxDistance' })
export class PhxDistancePipe implements PipeTransform {
  private readonly format = '1.2-2';

  constructor(private translationService: PhxTranslationService) {}

  /**
   * Formats the distance value to the specified unit accoriding to metric units.
   * 
   * @param {number | string | null} distance  - value to be formatted.
   * @param {boolean} isMetricUnits - Tells whether the distance value should be formatted to metric units or imperial units.
   * @param {PhxDistanceUnitType} [currentUnit='km'] - The unit of the distance value, either 'km' or 'mile'.
   * @remarks Format for distance will always be 1.2-2.
   * @returns formated distance value.
   */
  public transform(
    distance: number | string | null,
    isMetricUnits: boolean,
    currentUnit: PhxDistanceUnitType = 'km',
  ): string | number | null {
    if (distance == null || distance === '') return;

    distance = +distance; // convert to number
    if (isMetricUnits && currentUnit === 'mile') distance = milesToKm(distance);
    if (!isMetricUnits && currentUnit === 'km') distance = kmToMiles(distance);
    return formatNumber(distance, this.translationService.getLocale(), this.format);
  }
}
